import React from "react";
import {
  ExclamationCircleIcon,
  ArrowPathIcon,
  HomeIcon,
} from "@heroicons/react/24/outline";

interface ErrorScreenProps {
  title?: string;
  message?: string;
  errorCode?: string | number;
  onRetry?: () => void;
  onGoHome?: () => void;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  title = "Något gick fel",
  message = "Vi lyckades inte ladda innehållet. Ladda om sidan eller kontakta support.",
  errorCode,
  onRetry,
  onGoHome,
}) => {
  return (
    <div className="flex min-h-screen flex-col justify-center bg-gray-50 py-12 sm:px-6 lg:px-8">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white px-4 py-8 text-center shadow sm:rounded-lg sm:px-10">
          <ExclamationCircleIcon className="mx-auto h-12 w-12 text-red-500" />

          <h2 className="mt-6 text-center text-2xl font-bold text-gray-900">
            {title}
          </h2>

          {errorCode && (
            <p className="mt-2 text-sm text-gray-500">
              Error code: {errorCode}
            </p>
          )}

          <p className="text-md mt-4 text-gray-600">{message}</p>

          <div className="mt-6 flex justify-center space-x-4">
            {onRetry && (
              <button
                onClick={onRetry}
                className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <ArrowPathIcon className="-ml-1 mr-2 h-5 w-5" />
                Try Again
              </button>
            )}

            {onGoHome && (
              <button
                onClick={onGoHome}
                className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <HomeIcon className="-ml-1 mr-2 h-5 w-5" />
                Go to Dashboard
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Usage example:
//
// import ErrorScreen from './components/ErrorScreen';
//
// const MyPage: React.FC = () => {
//   const [hasError, setHasError] = useState(false);
//
//   const handleRetry = () => {
//     // Logic to retry loading the page
//     setHasError(false);
//   };
//
//   const handleGoHome = () => {
//     // Navigate to home/dashboard
//     router.push('/dashboard');
//   };
//
//   if (hasError) {
//     return (
//       <ErrorScreen
//         errorCode="500"
//         onRetry={handleRetry}
//         onGoHome={handleGoHome}
//       />
//     );
//   }
//
//   return <YourNormalPage />;
// };
